import React from "react";

const CopyIcon = ({
  className = "",
  color = "black",
  width = "19",
  height = "21",
  ...restProps
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...restProps}
    >
      <rect x='6' y='1' width='12' height='14' rx='2' stroke={color} />
      <rect
        x='1'
        y='6'
        width='12'
        height='14'
        rx='2'
        fill='white'
        stroke={color}
      />
    </svg>
  );
};

export default CopyIcon;
